import { env } from '../env';

export const termsOfUseBlueFinLink = 'https://www.bluefin.com/terms/';
export const termsOfUseHostedPciLink = 'https://www.authorize.net/about-us/terms.html';
export const supportEmail = `mailto:${env.VITE_SUPPORT_EMAIL}`;
export const idVerificationDocsLink = 'https://docs.vouched.id/docs/recognized-ids';
export const faqLink = 'https://www.dermatologistoncall.com/support';
